import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ListRemote} from "@app/core/lists/domain/list.remote";
import {List} from "@app/core/lists/domain/list";
import {ListGroup} from "@app/core/lists/domain/list-group";
import {map} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class GetAllListsUseCase {
    constructor(private listRemote:ListRemote) {
    }

    execute(): Observable<List[]> {
        return this.listRemote.getListGroups().pipe(map(listGroup => this.flat(listGroup)));
    }

    /**
     * Consolidates lists from all groups into a single array.
     * This flattening is performed so that in the view the lists appear as one single list, simplifying rendering and user interaction.
     * @param listGroups - The list groups to flatten.
     * @returns A flattened array of lists.
     */
    private flat(listGroups:ListGroup[]):List[] {
        let lists: List[] = []
        listGroups.forEach(
            listGroup => lists.push(...listGroup.lists)
        )
        return lists;
    }
}